var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.81 24.46H6.54999C4.48999 24.46 2.72999 23.06 2.26999 21.05L0.109991 11.71C-0.280009 10.03 0.359991 8.28 1.71999 7.23L10.01 0.9C11.58 -0.3 13.78 -0.3 15.35 0.9L23.64 7.23C25.01 8.27 25.64 10.03 25.25 11.71L23.09 21.05C22.63 23.06 20.87 24.46 18.81 24.46ZM11.23 2.49L2.93999 8.82C2.19999 9.39 1.84999 10.35 2.05999 11.26L4.21999 20.6C4.46999 21.69 5.42999 22.46 6.54999 22.46H18.81C19.93 22.46 20.89 21.7 21.14 20.6L23.3 11.26C23.51 10.35 23.17 9.39 22.42 8.82L14.13 2.49C13.27 1.84 12.08 1.84 11.22 2.49H11.23Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.68 16.83C12.28 16.83 11.87 16.71 11.52 16.47L9.03 14.74C8.62 14.46 8.52 13.9 8.8 13.49C9.08 13.08 9.64 12.98 10.05 13.26L12.54 14.99C12.62 15.04 12.72 15.04 12.8 14.99L15.29 13.26C15.7 12.98 16.26 13.08 16.54 13.49C16.82 13.9 16.72 14.46 16.31 14.74L13.82 16.47C13.47 16.71 13.07 16.83 12.66 16.83H12.68Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.36,
    height: 24.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHom1);
export default __webpack_public_path__ + "static/media/Hom_1.c8f89bf519e1ff7a5ced0085c2c98636.svg";
export { ForwardRef as ReactComponent };